import { batch } from 'react-redux';
import { validatePhoneSaga } from '../../Lib/redux/sagas/ValidatePhone/validatePhone';
import {
  setPhoneValidationConstraint,
  setComponentValidationStatus,
} from '../../Lib/redux/slices/components';
import ValidationStatus from '../../Data/ValidationStatus';
/**
 * Handles the validation of a phone number
 *
 * @param {string} componentId
 * @param {string} countryCode - i.e. US / GB / FR
 * @param {fn} dispatch - function to dispatch an action
 * @param {string} iFrameId
 * @param constraints
 * @param {string|int|undefined} formId
 * @returns undefined
 */
const validatePhone = ({
  value,
  componentId,
  countryCode,
  dispatch,
  iFrameId,
  constraints,
  formId,
}) => {
  batch(() => {
    dispatch(
      setPhoneValidationConstraint({
        status: ValidationStatus.VALID,
        componentId,
      })
    );
    dispatch(
      setComponentValidationStatus({
        componentId,
        countryCode,
        iFrameId,
        formId,
      })
    );
    dispatch(
      validatePhoneSaga({
        country: countryCode,
        number: value,
        componentId,
        iFrameId,
        constraints,
        formId,
      })
    );
  });
};

export default validatePhone;
